import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useContentItem } from '@/lib/hooks/useContent';
import { ContentDetailView } from '@/components/content/ContentDetailView';
import { ContentHubView } from '@/components/content/ContentHubView';
import { useSession } from '@/lib/auth-client';
export default function PublicContentDetailPage() {
  const $ = _c(24);
  const router = useRouter();
  const contentId = router.query.id as string || "";
  const backLabel = router.query.backLabel as string || undefined;
  const backHref = router.query.backHref as string || undefined;
  const t0 = !!contentId;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: item,
    isLoading,
    isPending
  } = useContentItem(contentId, t1);
  const {
    data: sessionData
  } = useSession();
  const isAdmin = sessionData?.user?.isAdmin === true;
  if (isPending) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="min-h-screen bg-gray-50 flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-gray-400" /></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!item && !isLoading) {
    router.replace("/content");
    return null;
  }
  if (item.type === "hub") {
    let t2;
    if ($[3] !== item) {
      t2 = <ContentHubView content={item} />;
      $[3] = item;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const t2 = item.title || "Untitled";
  let t3;
  if ($[5] !== t2) {
    t3 = <title>{t2} | Sizzle</title>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== item.content) {
    t4 = item.content && <meta name="description" content={item.content.slice(0, 160).replace(/[#*_\[\]]/g, "")} />;
    $[7] = item.content;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Head>{t3}{t4}</Head>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== backHref || $[13] !== backLabel) {
    t6 = (backLabel || backHref) && <div className="bg-white border-b border-gray-200"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4"><Link href={backHref || "/content"} className="inline-flex items-center text-gray-600 hover:text-gray-900 cursor-pointer"><ArrowLeft className="h-4 w-4 mr-2" />{backLabel || "Back"}</Link></div></div>;
    $[12] = backHref;
    $[13] = backLabel;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isAdmin || $[16] !== item) {
    t7 = <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"><ContentDetailView content={item} showMap={true} showEditButton={isAdmin} /></main>;
    $[15] = isAdmin;
    $[16] = item;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="min-h-screen bg-gray-50">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}